import { atom } from 'jotai';
// setup initial chrome atoms
export const contextSwitcherOpenAtom = atom(false);
